var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM11.9999 21.6C6.70786 21.6 2.39986 17.292 2.39986 12C2.39986 6.70802 6.70786 2.40002 11.9999 2.40002C17.2919 2.40002 21.5999 6.70802 21.5999 12C21.5999 17.292 17.2919 21.6 11.9999 21.6ZM9.60001 14.604L16.656 7.54801C17.124 7.08001 17.892 7.08001 18.36 7.54801C18.828 8.01601 18.828 8.77201 18.36 9.24001L10.452 17.148C9.98401 17.616 9.22801 17.616 8.76001 17.148L5.65201 14.04C5.18401 13.572 5.18401 12.816 5.65201 12.348C5.87621 12.1233 6.18059 11.997 6.49801 11.997C6.81543 11.997 7.11981 12.1233 7.34401 12.348L9.60001 14.604Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.9e03e7e6.svg";
export { ForwardRef as ReactComponent };